import React from 'react';
import PropTypes from 'prop-types';
import VamosMap from '../VamosMap';
import SitesInMarkers from '../VamosMap/SitesInMarkers';

const SitesMap = ({ sitesArray }) => {
  // to avoid error when sitesArray is null
  if (!sitesArray) {
    return null;
  }
  return (
    <VamosMap className="rounded-10px overflow-hidden w-full" height="40vw">
      <SitesInMarkers sitesArray={sitesArray} />
    </VamosMap>
  );
};

SitesMap.propTypes = {
  sitesArray: PropTypes.array.isRequired,
};

export default SitesMap;
